import { render, staticRenderFns } from "./OnestopProjectDetail.vue?vue&type=template&id=e98a3b9a"
import script from "./OnestopProjectDetail.vue?vue&type=script&lang=js"
export * from "./OnestopProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./OnestopProjectDetail.vue?vue&type=style&index=0&id=e98a3b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports